import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebinarsService {

  //list of published white papers
  private webinars: any[] = [
    { title: 'The Future of Compliance for Nuclear Utilities: Discover how AI and Machine Learning can Automate Your Most Time Intensive Compliance Related Tasks', url: 'https://atlasity.discoveraccelerant.com/auto-webinar-registration1605575544563'},
    { title: 'Security Automation Simplified via NIST OSCAL: We are not in Kansas Anymore - RSA Conference 2018', url: 'https://www.youtube.com/watch?v=eP8K7piU5UQ'},
    { title: 'Automating Security and Compliance via a New Standard of Standards - Docker Government Summit 2018', url: 'https://www.youtube.com/watch?v=mo3J0tFxixg'},
    { title: 'Cyber Security Controls: Data portability between vendor tools using NIST OSCAL - 2nd Open Security Controls Assessment Language Workshop', url: 'https://www.nist.gov/document/presentation-track-2-cyber-security-controls-data-portability-between-vendor-tools-using'},
    { title: 'Security v/s Compliance: Can you have both?', url: 'https://vimeo.com/701420560/4738b3cb4f'}
  ];

  //inject services
  constructor() { }

  //retrieves the list of webinars
  getWebinars() {
    return this.webinars;
  }
}
